/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../schemaTypes';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type TrackEventInput = {
  cohortId?: string | number | null | undefined;
  context?: unknown;
  entity?: string | null | undefined;
  entityId?: string | number | null | undefined;
  event: string;
  sourceURL: string;
};

export type TrackEventMutationVariables = Exact<{
  trackEventInput: Types.TrackEventInput;
}>;


export type TrackEventMutation = { track: string };


export const TrackEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"trackEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackEventInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"track"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trackEventInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackEventInput"}}}]}]}}]} as unknown as DocumentNode<TrackEventMutation, TrackEventMutationVariables>;